/* global axios */
import ApiClient from './ApiClient';

class MarketingAPI extends ApiClient {
  constructor() {
    super('marketing/campaigns', { accountScoped: true });
  }

  // One composition creates the post and the WhatsApp broadcast, so the image
  // travels once as multipart.
  create(formData) {
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  whatsappTemplates() {
    return axios.get(`${this.baseUrl()}/broadcasts/whatsapp_templates`);
  }

  // Forces the sync server-side instead of waiting for the scheduled one.
  syncWhatsappTemplates() {
    return axios.post(`${this.baseUrl()}/broadcasts/sync_whatsapp_templates`);
  }

  // Creates the template on the inbox's own WhatsApp Business account. Meta
  // reviews it afterwards, so it comes back PENDING.
  createWhatsappTemplate(inboxId, template) {
    return axios.post(`${this.baseUrl()}/whatsapp/templates`, {
      inbox_id: inboxId,
      template,
    });
  }
}

export default new MarketingAPI();
